export const TRANCHE_ORDER = [
  'no_intervention_necessary',
  'intervene_to_prevent_exacerbation',
  'intervene_to_prevent_unplanned_acute',
  'unintervenable_too_high_risk',
];

export const TRANCHE_LABELS = {
  no_intervention_necessary: 'No intervention necessary',
  intervene_to_prevent_exacerbation: 'Intervene to prevent exacerbation',
  intervene_to_prevent_unplanned_acute: 'Intervene to prevent unplanned acute',
  unintervenable_too_high_risk: 'Unintervenable (too high risk)',
};

export const TRANCHE_SHORT = {
  no_intervention_necessary: 'No intervention',
  intervene_to_prevent_exacerbation: 'Prevent exacerbation',
  intervene_to_prevent_unplanned_acute: 'Prevent unplanned acute',
  unintervenable_too_high_risk: 'Unintervenable',
};

export const TRANCHE_STYLES = {
  no_intervention_necessary: { hex: '#34d399', dot: 'bg-emerald-400', pill: 'bg-emerald-50 text-emerald-800 border border-emerald-200', bgLight: 'bg-emerald-50/60', text: 'text-emerald-800', border: 'border-emerald-300' },
  intervene_to_prevent_exacerbation: { hex: '#fbbf24', dot: 'bg-amber-400', pill: 'bg-amber-50 text-amber-800 border border-amber-200', bgLight: 'bg-amber-50/60', text: 'text-amber-800', border: 'border-amber-300' },
  intervene_to_prevent_unplanned_acute: { hex: '#fb7185', dot: 'bg-rose-400', pill: 'bg-rose-50 text-rose-800 border border-rose-200', bgLight: 'bg-rose-50/60', text: 'text-rose-800', border: 'border-rose-300' },
  unintervenable_too_high_risk: { hex: '#94a3b8', dot: 'bg-slate-400', pill: 'bg-slate-100 text-slate-700 border border-slate-200', bgLight: 'bg-slate-50', text: 'text-slate-700', border: 'border-slate-300' },
};

export const TRANCHE_DESCRIPTIONS = {
  no_intervention_necessary: 'Stable. No exacerbation or unplanned acute event expected in the next 12 months.',
  intervene_to_prevent_exacerbation: 'A chronic condition is slipping but the patient is not yet in a pattern of unplanned acute use. Early intervention keeps them out of the next tranche.',
  intervene_to_prevent_unplanned_acute: 'An unplanned admission or repeated ED use is expected in the next 12 months. Intervention aims to prevent that event.',
  unintervenable_too_high_risk: 'Death or irreversible decline expected within the year regardless of care management. Palliative planning, not care management.',
};

export const CATEGORY_LABELS = {
  transitional_care: 'Transitional care',
  longitudinal_care_management: 'Longitudinal care management',
  disease_management: 'Disease management',
  medication_management: 'Medication management',
  behavioral_health: 'Behavioral health',
  social_needs_navigation: 'Social needs navigation',
  palliative_and_advance_care_planning: 'Palliative and advance care planning',
  acute_use_redirection: 'Acute use redirection',
  none: 'None',
};

export const CONFIDENCE_STYLES = {
  high: 'bg-emerald-50 text-emerald-700',
  medium: 'bg-amber-50 text-amber-700',
  low: 'bg-gray-100 text-gray-500',
};

export const EVIDENCE_SOURCE_LABELS = {
  claims: 'Claims',
  ehr_medications: 'EHR medications',
  observations: 'Observations',
  encounters: 'Encounters',
  adt_episodes: 'Hospital episodes',
  appointments: 'Appointments',
  active_problem_list: 'Problem list',
  encounter_vitals: 'Vitals',
  current_medication_classes: 'Medication classes',
};
